export enum DROPDOWN_POSITION {
  FIXED = 'FIXED',
  FIXED_BOTTOM = 'FIXED_BOTTOM',
  TOP = 'TOP',
  TOP_LEFT = 'TOP_LEFT',
  BOTTOM = 'BOTTOM',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
}
export type DropdownRefElement = HTMLDivElement;
export type DropdownOnOpenEvent = MouseEvent | React.KeyboardEvent | React.MouseEvent;
export type DropdownOnOpen = (event: DropdownOnOpenEvent) => void;
export type DropdownOnCloseEvent = MouseEvent | KeyboardEvent | React.KeyboardEvent | React.MouseEvent;
export type DropdownOnClose = (event: DropdownOnCloseEvent) => void;
export type DropdownProps = {
  rootRef?: React.RefObject<DropdownRefElement>;
  bodyClassName?: string;
  position?: DROPDOWN_POSITION;
  offsetTop?: number | string;
  offsetBottom?: number | string;
  offsetLeft?: number | string;
  minWidth?: number | string;
  maxWidth?: number | string;
  withOverlay?: boolean;
  children: React.ReactNode;
  renderDropdown: (onClose: DropdownOnClose) => React.ReactNode;
  opened: undefined | boolean;
  disabled?: boolean;
  onOpen: DropdownOnOpen;
  onClose: DropdownOnClose;
};
export type DropdownBodyStyledProps = {
  position?: DROPDOWN_POSITION;
};
export type DropdownTriggerStyledProps = {
  disabled: undefined | boolean;
};